import { useCallback } from 'react';
import { useQueryClient } from '../../lib';
import { getCollectionsKey, getSpaceKey, getSpacesKey } from '../../utils/keys';
export const useInvalidateSpaceQuery = () => {
    const queryClient = useQueryClient();
    const invalidate = useCallback((spaceId) => {
        const collectionsKey = getCollectionsKey();
        const spacesKey = getSpacesKey();
        queryClient.invalidateQueries(spacesKey);
        const spaceKey = getSpaceKey({ variables: { id: spaceId } });
        queryClient.invalidateQueries(spaceKey);
        queryClient.invalidateQueries(collectionsKey);
    }, [queryClient]);
    return invalidate;
};
//# sourceMappingURL=useInvalidateSpaceQuery.js.map